import { Card, Table, Button, DatePicker, Row, Col, Tooltip } from "antd";
import moment from "moment-timezone";
import Loading from "../../common/Loading";
import { useReportTable } from "./index.hook";
import { General } from "../../../util/General";
import styles from "../../MasterManagement/index.module.less";
import { TableHelper } from "../../../util/TableHelper";
import { FilePdfOutlined } from "@ant-design/icons";
import CircularProgressBar from "../../common/CircularProgressBar";

import type { ColumnsType } from "antd/lib/table";
import type { RequestPerHourReportData } from "../../../shared/interface/Report/requestPerHourReport.interface";

const RequestPerHourReport = () => {
  const config = useReportTable();

  const columns: ColumnsType<RequestPerHourReportData> = [
    {
      align: "center",
      title: "Sr No.",
      dataIndex: "sr_no",
      key: "sr_no",
      sorter: {
        compare: TableHelper.digitSorter("sr_no")
      },
      render: TableHelper.renderText,
      width: "15%"
    },
    {
      title: "Hour",
      dataIndex: "hour",
      key: "hour",
      sorter: {
        compare: TableHelper.digitSorter("hour")
      },
      render: TableHelper.renderText
    },
    {
      align: "center",
      title: "Booking",
      dataIndex: "booking_count",
      key: "booking_count",
      sorter: {
        compare: TableHelper.digitSorter("booking_count")
      },
      render: TableHelper.renderText
    },
    {
      align: "center",
      title: "Retrieval",
      dataIndex: "retrieval_count",
      key: "retrieval_count",
      sorter: {
        compare: TableHelper.digitSorter("retrieval_count")
      },
      render: TableHelper.renderText
    }
  ];

  return (
    <Card
      className="gx-card card--height"
      title={
        <div className={`gx-title-container`}>
          <div className="card-title-style">REQUEST/HOUR REPORT</div>
          <div className={styles["iconButton-container"]}>
            <DatePicker format="DD-MM-YYYY" defaultValue={moment()} disabledDate={General.disabledDate} onChange={config.handleDateChange} getPopupContainer={(trigger) => trigger.parentElement || document.body} />
            <Button className="gx-mb-0 gx-ml-3 gx-mr-2" type="primary" disabled={!config?.selectedDate} onClick={config.fetchReportData}>
              Go
            </Button>
            <Tooltip title="Download PDF File">
              <div onClick={config.reportData?.length === 0 ? undefined : config.handleExportPDFFile}>{config.reportData?.length === 0 ? <FilePdfOutlined className={styles["pdf-icon-disabled"]} /> : config?.pdfIconLoading ? <CircularProgressBar /> : <FilePdfOutlined className={styles["pdf-icon"]} />}</div>
            </Tooltip>
          </div>
        </div>
      }
    >
      {config.loading ? (
        <Loading />
      ) : (
        <Row gutter={[16, 16]}>
          <Col xs={24} sm={24} md={12} lg={12} xl={12}>
            <Table
              className="gx-table-responsive"
              size="small"
              columns={columns}
              dataSource={config.reportData.slice(0, 12)}
              pagination={false} // Disable internal pagination
              rowKey={(record) => record.sr_no}
              bordered
            />
          </Col>
          <Col xs={24} sm={24} md={12} lg={12} xl={12}>
            <Table
              className="gx-table-responsive"
              size="small"
              columns={columns}
              dataSource={config.reportData.slice(12, 24)}
              pagination={false} // Disable internal pagination
              rowKey={(record) => record.sr_no}
              bordered
            />
          </Col>
        </Row>
      )}
    </Card>
  );
};

export default RequestPerHourReport;
